import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast from "react-hot-toast";
import { RiBankFill, RiBankCardFill } from "react-icons/ri";
import { BiShieldQuarter } from "react-icons/bi";

import { addbankDetails } from "../../service/api";

import { FaSpinner } from "react-icons/fa";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";

const AddbankDetails = () => {
  const navigate = useNavigate();

  const [accountNumber, setAccountNumber] = useState("");
  const [bankName, setBankName] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [upiId, setUpiId] = useState();

  const [isLoading, setisLoading] = useState(false);

  const submitBankDetails = async () => {
    setisLoading(true);
    const creator_data = JSON.parse(sessionStorage.getItem("creatordata"));

    if (
      accountNumber.length < 1 ||
      bankName.length < 1 ||
      ifsc.length < 1 ||
      upiId.length < 1
    ) {
      toast.error("Add All fields");
      setisLoading(false);
    } else {
      const data = {
        email: creator_data.email,
        bankName: bankName,
        accountNumber: accountNumber,
        ifsc: ifsc,
        upiId: upiId,
      };

      const response = await addbankDetails(data);
      setisLoading(false);
      if (response) {
        toast.success("Bank details added");

        navigate(-1);
      } else {
        toast.error("Error! please try again");
      }
    }
  };

  return (
    <div className="flex flex-col bg h-full min-h-screen justify-center items-center p-5">
      <h1 className="text-4xl font-bold m-3 text-white">
        Please Add your Bank Details To continue
      </h1>
      {isLoading && (
        <center className="py-20 my-20">
          <FaSpinner icon="spinner" className="spinner" size={70} />
        </center>
      )}

      {!isLoading && (
        <form className="w-full flex flex-col gap-2.5 font-semibold md:w-3/5 lg:w-1/2">
          {/* Account Number Input Section */}
          <div className="flex flex-col gap-1">
            <label className="text-white" htmlFor="phone">
              Account Number:
            </label>
            <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
              <span>
                <RiBankFill />
              </span>
              <input
                type="number"
                name="bank account number"
                placeholder="Enter your Account Number"
                className="w-full h-full outline-none"
                onChange={(e) => {
                  setAccountNumber(e.target.value);
                }}
              />
            </div>
          </div>

          {/* Bank Name Input Section */}
          <div className="flex flex-col gap-1">
            <label className="text-white" htmlFor="phone">
              Bank Name:
            </label>
            <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
              <span>
                <RiBankCardFill />
              </span>
              <input
                type="text"
                name="bank name"
                placeholder="Enter your Bank Name"
                className="w-full h-full outline-none"
                onChange={(e) => {
                  setBankName(e.target.value);
                }}
              />
            </div>
          </div>

          {/* Bank IFSC Code Input Section */}
          <div className="flex flex-col gap-1">
            <label className="text-white" htmlFor="phone">
              Bank IFSC Code:
            </label>
            <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
              <span>
                <BiShieldQuarter />
              </span>
              <input
                type="text"
                name="ifsc"
                placeholder="Enter your Bank IFSC Code"
                className="w-full h-full outline-none"
                onChange={(e) => {
                  setIfsc(e.target.value);
                }}
              />
            </div>
          </div>

          {/* Upi Id Input Section */}
          <div className="flex flex-col gap-1">
            <label className="text-white" htmlFor="phone">
              Upi Id:
            </label>
            <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
              <span>
                <FontAwesomeIcon icon={faMobileAlt} />
              </span>
              <input
                type="text"
                name="upi id"
                placeholder="Enter your Upi Id"
                className="w-full h-full outline-none"
                onChange={(e) => {
                  setUpiId(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="flex justify-center items-center mt-5">
            <button
              className="rounded-full text-center w-full px-4 py-1.5 bg-white text-cyan-700 font-bold"
              onClick={(e) => {
                e.preventDefault();
                submitBankDetails();
              }}
            >
              Add bank details
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddbankDetails;
